// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"749f6e84","95":"4482945e","149":"4fc0825a","233":"78a72034","244":"0f0c9309","246":"91b85d1b","343":"eaf16e49","442":"7002af50","617":"cecf6bfe","629":"bda864a0","729":"a55f7047"}[chunkId] + ".chunk.js";
};